<template>
    <div>
        <div class="page my-14">
            <div class="container px-11 2xl:px-3 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>
                <div class="block lg:flex mb-8">
                    <div class="w-full lg:w-3/4 relative">
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    '4000 ans d’innovation et les prix EDF Pulse'
                                ),
                            }"
                            class="top-2 xl:top-8 right-2"
                        />
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage1.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage1.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>

                    <div class="card w-full lg:w-1/4 flex flex-col relative">
                        <p
                            class="
                                pb-5
                                text-tundora
                                lg:p-5
                                font-bold
                                text-xs
                                2xl:text-lg
                            "
                            v-html="
                                currentPage.content.sParagraphOne_Title.text
                            "
                        ></p>
                        <div class="q10__center-container">
                            <div class="text-center">
                                <div
                                    class="text-dodger_blue font-bold text-2xl"
                                    v-html="
                                        currentPage.content.sParagraphTwo_Title
                                            .alt
                                    "
                                ></div>
                                <TitleParagraph
                                    :options="{
                                        from: 'from-selective_green',
                                        to: 'to-golden_sand',
                                    }"
                                    ><p
                                        class="
                                            text-4xl
                                            font-bold
                                            text-base
                                            2xl:text-lg
                                        "
                                        v-html="
                                            currentPage.content
                                                .sParagraphTwo_Title.title
                                        "
                                    ></p>
                                </TitleParagraph>
                            </div>
                            <div class="h-40 w-40 m-auto relative">
                                <image-with-descriptions
                                    style="right: -0.5rem"
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.oImage2.src,

                                        color: 'text-nandor',
                                    }"
                                />
                                <span
                                    class="q10__copyright"
                                    v-html="currentPage.images.oImage2.edf"
                                ></span>
                            </div>

                            <div class="flex justify-center items-center">
                                <TitleParagraph
                                    :options="{
                                        from: 'from-selective_green',
                                        to: 'to-golden_sand',
                                    }"
                                >
                                    <span
                                        class="text-9xl"
                                        v-html="
                                            currentPage.content
                                                .sParagraphThree_Title.text
                                        "
                                    >
                                    </span>
                                </TitleParagraph>
                                <TitleParagraph
                                    :options="{
                                        from: 'from-selective_green',
                                        to: 'to-golden_sand',
                                    }"
                                >
                                    <span
                                        class="font-bold text-base 2xl:text-lg"
                                        v-html="
                                            currentPage.content
                                                .sParagraphFour_Title.text
                                        "
                                    >
                                    </span>
                                    <div class="relative">
                                        <hotspot-richmedia
                                            :options="{
                                                icon: 'diaporama',
                                                collection:
                                                    getRichmediaByCollection(
                                                        currentPage,
                                                        'Présentation de la HyFactory par JC Rigaut'
                                                    ),
                                            }"
                                            class="top-2 right-2"
                                        />
                                    </div>
                                </TitleParagraph>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <img
                        :src="
                            $i18n.locale +
                            '/images/pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.oImage3.src
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.q10__copyright {
    bottom: 30%;
    position: absolute;
    right: -40%;
    transform: rotate(-90deg);
    font-size: 14px;
}

.q10__center-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 1024px) {
        bottom: 0;
        top: unset;
        transform: translate(-50%, 0%);
    }
    @media (max-width: 991px) {
        position: relative;
    }
}
</style>
